export default __webpack_public_path__ + "static/zhijian2-5d5636a8a3ff9c998a78279918c6dd8a.jpg";